import { render, staticRenderFns } from "./Header-Module.vue?vue&type=template&id=3b75e4fc&"
import script from "./Header-Module.vue?vue&type=script&lang=js&"
export * from "./Header-Module.vue?vue&type=script&lang=js&"
import style0 from "./Header-Module.vue?vue&type=style&index=0&id=3b75e4fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports